var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-card border border-gray-50"},[_c('div',{staticClass:"px-4"},[(_vm.loading)?[_c('div',{staticClass:"h-40 flex items-center justify-center"},[_c('loading-icon',{staticClass:"w-5 h-5 text-pink-500"})],1)]:[_vm._v(" "+_vm._s(_vm.$route.params.action)+" ")]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }